<template>
  <div>
    <v-card
      flat
    >
      <div
        class="d-flex"
      >
        <v-card-text
          class="font-weight-bold title text-center"
        >서비스 이용 정보</v-card-text>
        <v-btn
          small
          color="error"
          style="position:absolute;margin-left:auto;margin-right:0;right:0;top:10%"
          to="/payment"
        >요금 안내</v-btn>
      </div>


      <v-divider></v-divider>
      <v-card-text
        align="center"
        v-if="subscriptions && subscriptions.length === 0"
        >서비스 이용 정보가 없습니다.
      </v-card-text>

      <v-simple-table>
        <tbody>
          <tr
            v-for="subscription in subscriptions"
            v-bind:key="subscription.key"
          >
            <td>{{getCategoryName(subscription.value.productCategory)}}</td>
            <td>
                <div>
                  <span>{{getSubscriptionDesc(subscription.value)}}</span>
                  <v-chip
                    :class="subscriptingChipClass(subscription.value)"
                    x-small
                  >{{isSubscriptingDesc(subscription.value)}}
                  </v-chip>
                </div>
              </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import { api } from '../mixins/api.js'
import { formUtility } from '../mixins/formUtility';

export default {
  async created() {
    await this.getSubscriptions();
  },
  data() {
    return {
      subscriptions: null
    }
  },
  methods: {
    async getSubscriptions() {
      this.subscriptions = await api.methods.getSubscriptionsApi();
    },
    getCategoryName(v) {
      switch (v) {
        case 1:
          return '리치고 부동산';
        case 2:
          return '리치고 경제';
        case 100:
          return '아파트 전망 리포트';
        case 101:
          return '경제 전망 리포트';
        default:
          return v;
      }
    },
    isSubscripting(v) {
      const now = Date.now();
      const startTime = new Date(v.startTime);
      const endTime = new Date(v.endTime);
      return startTime.getTime() <= now && now < endTime.getTime();
    },
    isSubscriptingDesc(v) {
      return this.isSubscripting(v) === true ? '서비스 이용중' : ' 서비스 종료';
    },
    subscriptingChipClass(v) {
      return (this.isSubscripting(v) === true ? 'accent' : 'default') + ' ma-2';
    },
    getSubscriptionDesc(v) {
      const startTime = new Date(v.startTime);
      const endTime = new Date(v.endTime);
      return `${startTime.format('yyyy-MM-dd (KS) HH:mm:ss')} ~ ${endTime.format('yyyy-MM-dd (KS) HH:mm:ss')}`;
    }
  },
  mixins: [formUtility]
}
</script>
